import type { Branded } from "@@/utilities/branded";
import { emptyArrayOf } from "./empty";

type CommaSeparatedString<T extends string = string> = Branded<
    T,
    "CommaSeparatedString"
>;
/**
 * Separates string by comma and outputs an array WITHOUT DUPLICATES
 * and if provided only matching items in the valid values array
 * @template T
 * @param {CommaSeparatedString} input
 * @param {string[]} validValues
 * @returns {T[]}
 */
const splitCommaSeparatedString = <T extends string>(
    input: CommaSeparatedString | undefined,
    validValues?: string[],
): T[] => {
    if (!input) return emptyArrayOf<T>();
    return Array.from(
        new Set(
            input
                .split(",")
                .map(value => value.trim())
                .filter(
                    value =>
                        !validValues?.length || validValues.includes(value),
                ) as T[],
        ),
    );
};

const commaSeparatedStringToArray = <T extends string>(
    value: CommaSeparatedString<T>,
): T[] => {
    return value.split(",") as T[];
};

export { commaSeparatedStringToArray, splitCommaSeparatedString };
export type { CommaSeparatedString };
